export default "__VITE_ASSET__DBdyR5EN__"